import { render } from "./footer.vue?vue&type=template&id=157f421a&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import "./footer.vue?vue&type=style&index=0&id=157f421a&scoped=true&lang=scss"

import exportComponent from "C:\\Project\\DeepLink2\\DeepLinkWebsite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-157f421a"]])

export default __exports__